import React, { Component } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import Container from "upn-component-container";
import { css } from "emotion";

const styles = css`
  & .upn__modal__content-base {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    background: #fafafa;
    border: 1px solid #ccc;
    margin: 2em 0;
    box-shadow: 2px 2px 5px rgba(128, 128, 128, 0.5);
    padding: 0;
    border-color: #808080;
    text-align: center;
  }

  & .upn__modal__content-afterOpen {
    background: rgb(255, 255, 255);
  }

  & .upn__modal__content-beforeClose {
    background: rgba(255, 0, 0, 0.75);
    padding: 20px;
  }

  & > .upn__modal__overlay-base {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
  }

  & > .upn__modal__overlay-afterOpen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
  }

  & > .upn__modal__overlay-beforeClose {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
  }

  & .upn__modal__content-base > div > .container.upn-modal-container {
    margin: 0;
    .scrollable-content {
      max-width: 90vw;
      min-width: 20vw;
      max-height: 75vh;
      overflow: auto;
    }
  }
`;

export default class UPN_Modal extends Component {
  static propTypes = {
    className: PropTypes.string,
    heading: PropTypes.string,
    message: Container.propTypes.message,
    messageTheme: Container.propTypes.messageTheme,
    children: Container.propTypes.children,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onOk: PropTypes.func,
    okText: PropTypes.string,
    okDisabled: PropTypes.bool,
  };

  static defaultProps = {
    isOpen: false,
    onClose: () => {},
    okText: "OK"
  };

  componentWillMount = () => {
    Modal.setAppElement("body");
  };

  render() {
    let classNames = ["UPN-modal"];
    if (this.props.className) {
      classNames.push(this.props.className);
    }
    classNames.push(styles);
    let buttons = (this.props.onOk) ? {
      buttonLeft: {
        text: "Cancel",
        onClick: this.props.onClose,
        size: "large",
        theme: "danger"
      },
      buttonRight: {
        text: this.props.okText,
        onClick: this.props.onOk,
        size: "large",
        theme: "success",
        disabled: this.props.okDisabled
      }
    } : { 
      buttonMiddle: {
        text: "Close",
        onClick: this.props.onClose,
        size: "large",
        theme: "danger"
      }
    }
    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onClose}
        contentLabel={this.props.heading}
        shouldCloseOnOverlayClick={true}
        className={{
          base: "upn__modal__content-base",
          afterOpen: "upn__modal__content-afterOpen",
          beforeClose: "upn__modal__content-beforeClose"
        }}
        overlayClassName={{
          base: "upn__modal__overlay",
          afterOpen: "upn__modal__overlay-afterOpen",
          beforeClose: "upn__modal__overlay-beforeClose"
        }}
        portalClassName={classNames.join(" ")}
        //parentSelector={() => window.top.document.body}
      >
        <Container
          {...buttons}
          className="upn-modal-container"
          heading={this.props.heading}
          message={this.props.message}
          messageTheme={this.props.messageTheme}
        >
          <div className="scrollable-content">{this.props.children}</div>
        </Container>
      </Modal>
    );
  }
}
